<img src="./assets/images/sx-logo-blue.png" class="print print-logo" aria-hidden="true" />
<h1 class="print print-hcf-header" aria-hidden="true">Healthcare finder</h1>
<div class="message-box" *ngIf="showMessage" [ngClass]="messageBoxClass">
  <div class="message">
    {{ messageText }}
    <span class="close" (click)="onCloseClick()" aria-label="Close">close</span>
  </div>
</div>
<hcf-banner></hcf-banner>
<hcf-search-input></hcf-search-input>
<div class="route-loader" *ngIf="isLoading"><span class="spinner"></span></div>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
<hcf-footer></hcf-footer>
